<script>
import { validate } from '../../utils/utils'
import CampaignTypeSelector from '../cc/campaign-setup/CampaignTypeSelector'
import Card from '../../slds/Card'
import GenericFilter from '../../campaign-manager/filters/GenericFilter'
import HasMode from '../../utils/HasMode'
import Input from '../../slds/Input'
import moment from 'moment'
import OutputField from '../../slds/OutputField'
import Picklist from '../../slds/Picklist'
import Spinner from '../../Spinner'
import TextArea from '../../slds/TextArea'
export default {
  mixins: [HasMode],
  components: {
    Card,
    CampaignTypeSelector,
    GenericFilter,
    Input,
    OutputField,
    Picklist,
    Spinner,
    TextArea
  },
  beforeDestroy (){
    this.gotAssetLists = false
  },
  props: {
    campaignStatus: String,
    loading: Boolean,
    mode: String
  },
  computed: {
    getSelectedBrandAbbrArray() {
      let abbr_arr = []
      for(let i = 0; i < this.campaignBrands.length; i++) {
        abbr_arr.push(this.brand_abr.options[this.campaignBrands[i]])
      }
      return abbr_arr;
    },
    getSelectedMarketAbbrArray() {
      let abbr_arr = []
      for(let i = 0; i < this.markets.length; i++) {
        abbr_arr.push(this.market_abr.options[this.markets[i]])
      }
      return abbr_arr;
    },
    computeCampaignName () {
      if (this.isCreate || this.isEdit) {
      const regex = /[^a-zA-Z0-9]/g;
      const _bu = this.$store.getters['session/decodedAccessToken']['businessUnitId']
      let _businessunit = this.bu_abr.options[_bu] || _bu
      let _market = 'market'
      if (this.markets.length > 0) _market = (this.markets.length == 1) ? this.market_abr.options[this.markets[0]] : 'multi'
      let _brand = 'brand'
      if (this.campaignBrands.length > 0) _brand = (this.campaignBrands.length == 1) ? this.brand_abr.options[this.campaignBrands[0]].replace(regex, '') : 'multi'
      let _maintarget = this.maintarget
      let _label = (this.name == '') ? 'label' : this.name.replace(regex, '')
      let _businesstype = this.businesstype.replace(regex, '')
      let _campaigntype = (this.campaignType.value == undefined) ? 'camptype' : this.campaignType.value.replace(regex, '')
      let _category = this.campaigncategory ? this.campaigncategory.replace(regex, '') : 'category'  

      this.namecomputed = _businessunit + '_' + _market + '_' + _brand + '_' + _maintarget + '_'
                                        + _label + '_' + _businesstype + '_' + _campaigntype + '_' + _category
      }
      //return this.namecomputed
    }
  },
  methods: {
    async callLoadFromStore () {
      const campaign = this.loadFromStore('campaignData', ['loading', 'oldConfig'])
      this.utm_campaign = '<ID>'
      if( campaign )
      {
        if (campaign.id) this.utm_campaign = campaign.id
        this.utm_selected = campaign.emailList ? campaign.emailList : []
        this.sms_selected = campaign.smsList ? campaign.smsList : []
        this.push_selected = campaign.pushList ? campaign.pushList : []
      }
      this.localConfig = this.$store.getters['campaignDesigner/state'].currentCampaignConfig
      if (!this.isCreate) this.brandOptions = this.localConfig.campaignData.campaignBrands.options
      else this.brandOptions = (this.localConfig.campaignData.brandOptions) ? this.localConfig.campaignData.brandOptions : this.localConfig.campaignData.campaignBrands.options

      if (this.localConfig.campaignData.masterKey && this.localConfig.campaignData.masterKey.options) {
        this.masterKeys = this.localConfig.campaignData.masterKey.options
      } else {
        this.masterKeys = (await this.$store.dispatch('settings/getSettings')).masterKeys
      }

      if (campaign.config.campaignData && campaign.config.campaignData.type && campaign.config.campaignData.type.selected) {
        const selectedType = campaign.config.campaignData.type.selected
        this.campaignType = {
          label: selectedType.name,
          value: selectedType.code,
          color: selectedType.color,
          disableOrchestrationFlagEditable: selectedType.disableOrchestrationFlagEditable,
          disableOrchestrationFlagDefault: selectedType.disableOrchestrationFlagDefault
        }
      }

      if (!this.contributionType) {
        this.contributionType = ''
      }

      this.assetInfoConfig = {};
      let PublishedAssetsIds = []
      const assetInfo = await this.$store.dispatch('campaignDesigner/getAssets')
      try {
        const PublishedAssets = await this.$store.dispatch('campaignDesigner/getPublishedAssets')
        PublishedAssetsIds = PublishedAssets[0].assets
      } catch(err) {
        console.error(err)
      }
      if (assetInfo && assetInfo.type){
        for (let i = 0; i < assetInfo.type.length; i++) {
          if (PublishedAssetsIds.includes(assetInfo.id[i])) {
            continue;
          }
          let knownType = true;
          if (assetInfo.type[i] == 'email') {
            this.utm_list.push(assetInfo.computedName[i]);
          }
          else if (assetInfo.type[i] == 'sms') {
            this.sms_list.push(assetInfo.computedName[i]);
          }
          else if (assetInfo.type[i] == 'push') {
            this.push_list.push(assetInfo.computedName[i]);
          }
          else knownType = false;

          if (knownType) {
            this.assetInfoConfig[ assetInfo.computedName[i] ] = {
              name: assetInfo.name[i],
              id: assetInfo.id[i],
              type: assetInfo.type[i],
              computedName: assetInfo.computedName[i],
              createdDate: assetInfo.createdDate[i],
              modifiedDate: assetInfo.modifiedDate[i],
              createdBy: assetInfo.createdBy[i],
              modifiedBy: assetInfo.modifiedBy[i],
              createdById: assetInfo.createdById[i],
              modifiedById: assetInfo.modifiedById[i]
            }
          }
        }
      }
      this.gotAssetLists = true
      //console.log(campaign.config.campaignData.campaignBrands)
      this.brand_user = this.$store.getters['session/decodedAccessToken']['brands']
      this.brandOptions = this.brand_user;
      //console.log('CAMPAIGN CONFIG BRANDS', campaign.config.campaignData.campaignBrands.options )
      if (this.isCreate) {
        let brandCodes = this.localConfig.campaignData.brand_abr.options;
        let swapped = {};

        for(let key in brandCodes){ swapped[brandCodes[key]] = key; }
        brandCodes = swapped;

        //If brand_user is AC, FIAT etc instead of 090, 091, then convert it from AC -> 090 etc.
        for (let i = 0; i < this.brand_user.length; i++) {
          const brandName = this.brand_user[i];
          if (brandCodes[brandName]) {
            this.brand_user[i] = brandCodes[brandName];
          }
        }

        this.brandOptions = this.brand_user.filter(
          br => campaign.config.campaignData.campaignBrands.options.includes(br)
        )
      }

    },
    getSectionToSave () {
      let assetFinal = [];
      let assetType = ['utm_selected', 'sms_selected', 'push_selected']
      for(let t=0; t<assetType.length; t++ ){
        for(let i=0;i<this[assetType[t]].length;i++){
          if( this.assetInfoConfig[ this[assetType[t]][i] ] ){
            assetFinal.push( this.assetInfoConfig[ this[assetType[t]][i] ] )
          }
        }
      }
      this.assetFinal = assetFinal

      const campaignType = {
        options: this.localConfig.campaignData.type.options,
        selected: this.localConfig.campaignData.type.options.find(type => type.code === this.campaignType.value)
      }

      const sectionToSave = {
        flat: {
          campaignChannel: this.campaignChannel,
          selected_market_abr: this.getSelectedMarketAbbrArray,
          selected_brand_abr: this.getSelectedBrandAbbrArray,
          campaigncategory: this.campaigncategory,
          business_area: 'AFTER_SALES',
          businessunit: this.$store.getters['session/decodedAccessToken']['businessUnitId'],
          namecomputed: this.namecomputed,
          businesstype: this.businesstype,
          maintarget: this.maintarget,
          utm_source: this.utm_source_computed || null,
          utm_medium: this.utm_medium_computed || null,
          utm_campaign: this.utm_campaign || null,
          utm_content: this.utm_content || null,
          sms_list: this.sms_selected || [],
          push_list: this.push_selected || [],
          email_list: this.utm_selected || [],
          brands: this.campaignBrands,
          ccdbReportEnabled: this.ccdbReportEnabled,
          ccdbReportType: this.ccdbReportType,
          contentClassification: this.contentClassification,
          contributionType: this.contributionType,
          description: this.description,
          finality: this.finality,
          marketCodes: this.markets,
          endDate: moment(this.endDate).format('YYYY-MM-DD'),
          manager: this.manager,
          masterKey: this.masterKey,
          name: this.name,
          onlyHeader: true,
          recordType: 'technical',
          segmentType: this.segmentType,
          touchpoint: this.touchpoint,
          type: this.campaignType.value,
          startDate: moment(this.startDate).format('YYYY-MM-DD')
        },
        config: {
          namecomputed: this.namecomputed,
          bu_abr: this.bu_abr,
          brand_abr: this.brand_abr,
          market_abr: this.market_abr,
          assetInfo: this.assetFinal,
          utm_source: this.utm_source_computed,
          utm_medium: this.utm_medium_computed,
          utm_campaign: this.utm_campaign,
          utm_content: this.utm_content,
          maintarget: {
            options: this.localConfig.campaignData.maintarget.options,
            selected: this.maintarget
          },
          campaigncategory: {
            options: this.localConfig.campaignData.campaigncategory.options,
            selected: this.campaigncategory
          },
          businesstype: {
            options: this.localConfig.campaignData.businesstype.options,
            selected: this.businesstype
           },
          campaignBrands: {
            options: this.localConfig.campaignData.campaignBrands.options,
            selected: this.campaignBrands
          },
          campaignChannel: {
            options: this.localConfig.campaignData.campaignChannel.options,
            selected: this.campaignChannel
          },
          ccdbReportEnabled: {
            options: this.localConfig.campaignData.ccdbReportEnabled.options,
            selected: this.ccdbReportEnabled
          },
          ccdbReportType: {
            options: this.localConfig.campaignData.ccdbReportType.options,
            selected: this.ccdbReportType
          },
          contentClassification: {
            options: this.localConfig.campaignData.contentClassification.options,
            selected: this.contentClassification
          },
          contributionType: {
            options: this.localConfig.campaignData.contributionType.options,
            selected: this.contributionType
          },
          description: this.description,
          favorite: {
            options: this.localConfig.campaignData.favorite.options,
            selected: this.favorite
          },
          finality: {
            options: this.localConfig.campaignData.finality.options,
            selected: this.finality
          },
          manager: {
            options: this.localConfig.campaignData.manager.options,
            selected: this.manager
          },
          markets: {
            options: this.localConfig.campaignData.markets.options,
            selected: this.markets
          },
          masterKey: {
            selected: this.masterKey
          },
          seed: {
            options: this.localConfig.campaignData.seed.options,
            selected: this.seed
          },
          segmentType: {
            options: this.localConfig.campaignData.segmentType.options,
            selected: this.segmentType
          },
          type: campaignType
        }
      }

      if (this.localConfig.campaignData.touchpoint) {
        sectionToSave.flat.touchpoint = this.touchpoint
        sectionToSave.config.touchpoint = {
          options: this.localConfig.campaignData.touchpoint.options,
          selected: this.touchpoint
        }
      }

      if (this.localConfig.campaignData.jeepWave) {
        sectionToSave.config.jeepWave = {
          options: this.localConfig.campaignData.jeepWave.options,
          selected: this.jeepWave
        }
        sectionToSave.flat.jeepWave = this.jeepWave
      }

      return sectionToSave
    },
    validate () {
      if (this.isCreate || this.isEdit) {
        return validate(this, 'data', true)
      } else {
        const dateFrom = moment(this.startDate, 'YYYY-MM-DD')
        if (this.campaignStatus === 'Draft' && dateFrom.isBefore(moment(), 'day')) {
          this.showToast('error', this.$t('validation.invalidData'), 'text', this.$t('campaignDesigner.campaignSetup.validation.startDateMustBeInFuture'))
        } else {
          return true
        }
      }
    }
  },
  beforeCreate () {
    this.$emit('startLoading')
  },
  created () {
    this.callLoadFromStore()
    this.$emit('endLoading')
  },
  data () {
    return {
      brand_scopes: [],
      brand_user: undefined,
      brandOptions: [],
      bu_abr: undefined,
      brand_abr: undefined,
      market_abr: undefined,
      assetInfoConfig: [],
      businesstype: [],
      maintarget: [],
      campaigncategory: [],
      namecomputed: '',
      push_list: [],
      sms_list: [],
      utm_list: [],
      gotAssetLists: false,
      utm_selected: [],
      sms_selected: [],
      push_selected: [],
      utm_source_computed: 'sfmc',
      utm_medium_computed: 'email',
      utm_source: '',
      utm_medium: '',
      utm_campaign: '<ID>',
      utm_content: '',
      campaignBrands: [],
      campaignChannel: [],
      campaignType: {},
      ccdbReportEnabled: false,
      ccdbReportType: '',
      contentClassification: '',
      contributionType: '',
      description: '',
      endDate: '',
      favorite: false,
      finality: '',
      jeepWave: [],
      localConfig: {},
      manager: '',
      markets: [],
      masterKey: '',
      masterKeys: [],
      name: '',
      onlyHeader: true,
      recordType: 'technical',
      seed: false,
      segmentType: '',
      startDate: moment()._d,
      touchpoint: '',
      type: ''
    }
  },
  watch: {
    campaignBrands (newValue) {
      this.computeCampaignName
      if (!newValue.includes('057')) {
        this.jeepWave = ''
      }
    },
    endDate () {
      //console.log(this.endDate)
      if (this.isCreate || this.isEdit) {
        this.$refs.data_startDate.clearValidationError()
      }
    },
    campaignChannel (value) {
      if (!this.campaignChannel.includes('email') && (this.isCreate)) {
        this.utm_selected = []
        // this.utm_campaign = ''
        // this.utm_medium = ''
        // this.utm_source = ''
      }
      if (!this.campaignChannel.includes('push') && (this.isCreate)) {
        this.push_selected = []
      }
      if (!this.campaignChannel.includes('sms') && (this.isCreate)) {
        this.sms_selected = []
      }
    },
    name (value) {
      const regex = /[^a-zA-Z0-9]/g;
      this.name = value.replace(regex, '')
      this.computeCampaignName
    },
    markets (value) {
      this.computeCampaignName
    },
    maintarget (value) {
      this.computeCampaignName
    },
    businesstype (value) {
      this.computeCampaignName
    },
    campaignType (value) {
      this.computeCampaignName
    },
    campaigncategory (value) {
      this.computeCampaignName
    },
    masterKey (value) {
      if (value === '') {
        this.masterKey = null
      }
    }
  }
}
</script>
<template>
  <div class="full-height">
    <Spinner v-if="loading" />

    <div v-else-if="localConfig && localConfig.campaignData" class="full-height">
      <Card class="full-height">
        <!-- Computed Name -->
        <div class="row">
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--large col">
              <Input
                  :label="$t('campaignDesigner.campaignSetup.namecomputed')"
                  :disabled="true"
                  ref="namecomputed"
                  v-if="isCreate || isEdit"
                  v-model="namecomputed" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.namecomputed')"
                  :value="namecomputed"
                  v-else />
            </div>
          </div>
        </div>
        <!-- Name, type -->
        <div class="row">
          <!-- Name -->
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.name')"
                :validation="['required']"
                ref="data_name"
                v-if="isCreate || isEdit"
                v-model="name" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.name')"
                :value="name"
                v-else />
            </div>
          </div>

          <!-- Campaign type selection -->
          <div class="slds-form-element slds-size--medium col">
            <CampaignTypeSelector
              ref="data_campaignType"
              v-if="isCreate && localConfig.campaignData.type.options.length > 1"
              v-model="campaignType"
              :options="localConfig.campaignData.type.options"
              :validation="['required']" />

            <OutputField :label="$t('campaignDesigner.campaignSetup.type.label')" type="custom" v-else>
              <span class="slds-swatch type-color-container" :style="`background:${campaignType.color ? campaignType.color: '#FFFFFF'};`" />
              <span>{{campaignType.label}}</span>
            </OutputField>
          </div>
        </div>

        <!-- Campaign Category -->
        <div class="row">
          <!-- Campaign Category-->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.campaigncategory.label')"
              :options="localConfig.campaignData.campaigncategory.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.campaigncategory"
              ref="data_campaigncategory"
              v-if="(isCreate || isEdit)"
              v-model="campaigncategory" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.campaigncategory.label')"
              :options="localConfig.campaignData.campaigncategory.options"
              :value="campaigncategory"
              labels-prefix="campaignDesigner.campaignSetup.campaigncategory"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Business Type, Main Target -->
        <div class="row">
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.businesstype.label')"
              :options="localConfig.campaignData.businesstype.options"
              :validation="['required']"
              :sortLabel=true
              labels-prefix="campaignDesigner.campaignSetup.businesstype"
              ref="data_businesstype"
              v-if="(isCreate || isEdit)"
              v-model="businesstype" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.businesstype.label')"
              :options="localConfig.campaignData.businesstype.options"
              :value="businesstype"
              labels-prefix="campaignDesigner.campaignSetup.businesstype"
              type="picklist"
              v-else />
          </div>

          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.maintarget.label')"
              :options="localConfig.campaignData.maintarget.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.maintarget"
              ref="data_maintarget"
              v-if="(isCreate || isEdit)"
              v-model="maintarget" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.maintarget.label')"
              :options="localConfig.campaignData.maintarget.options"
              :value="maintarget"
              labels-prefix="campaignDesigner.campaignSetup.maintarget"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Masterkey, Market -->
        <div class="row">
          <!-- Masterkey campaign -->
          <div class="slds-form-element slds-size--medium col" v-if="masterKeys && masterKeys.length">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.masterKey')"
              :options="masterKeys"
              :validation="['required']"
              show-empty-value
              ref="data_masterkey"
              searchable
              v-if="isCreate || isEdit"
              v-model="masterKey" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.masterKey')"
              :value="masterKey"
              type="custom"
              v-else>

              <span v-if="masterKeys && masterKeys.length && masterKey">{{masterKey.length && masterKeys.find(mk => mk.value === masterKey).label}}</span>
            </OutputField>
          </div>

          <!-- Market -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.market')"
              :options="localConfig.campaignData.markets.options"
              :validation="['required']"
              :sortLabel=true
              labels-prefix="markets"
              include-all-value
              multipicklist
              searchable
              ref="data_markets"
              v-if="(isCreate || isEdit)"
              v-model="markets" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.market')"
              :options="localConfig.campaignData.markets.options"
              :value="markets"
              labels-prefix="markets"
              type="multipicklist"
              v-else />
          </div>
        </div>

        <!-- Start date, End date -->
        <div class="row">
          <!-- Start date -->
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.startDate')"
                :validation="[{name: 'is-date-before', param: endDate}, 'is-date-after-today', 'required']"
                ref="data_startDate"
                type="date"
                v-if="isCreate || isEdit"
                v-model="startDate" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.startDate')"
                :value="startDate"
                type="date"
                v-else />
            </div>
          </div>

          <!-- End date -->
          <div class="slds-form-element slds-size--medium col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.endDate')"
                :validation="['required', 'is-date-after-today']"
                ref="data_endDate"
                type="date"
                v-if="isCreate || isEdit"
                v-model="endDate" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.endDate')"
                :value="endDate"
                type="date"
                v-else />
            </div>
          </div>
        </div>

        <!-- Brands, Channels -->
        <div class="row">
          <!-- Brands -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.brands')"
              :options="brandOptions"
              :validation="['required']"
              :sortLabel=true
              labels-prefix="brands"
              multipicklist
              :include-all-value="brandOptions.length > 0"
              ref="data_brands"
              v-if="(isCreate || isEdit)"
              v-model="campaignBrands" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.brands')"
              :options="brandOptions"
              :value="campaignBrands"
              labels-prefix="brands"
              type="multipicklist"
              v-else />
          </div>

          <!-- Channels -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.channels.label')"
              :options="localConfig.campaignData.campaignChannel.options"
              :validation="['required']"
              labels-prefix="channels"
              multipicklist
              ref="data_channels"
              v-if="isCreate || isEdit"
              v-model="campaignChannel" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.channels.label')"
              :options="localConfig.campaignData.campaignChannel.options"
              :value="campaignChannel"
              labels-prefix="channels"
              type="multipicklist"
              v-else />
          </div>
        </div>

        <!-- Contribution Type, Segment Type -->
        <div class="row">
          <!-- Contribution Type -->
          <div class="slds-form-element col slds-size--medium">
            <GenericFilter
              filter-type="included"
              is-picklist
              labels-prefix="campaignDesigner.campaignSetup.contributionType"
              v-if="isCreate || isEdit"
              v-model="contributionType"
              :options="localConfig.campaignData.contributionType.options"
              :label="$t('campaignDesigner.campaignSetup.contributionType.label')" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.contributionType.label')"
              :options="localConfig.campaignData.contributionType.options"
              :value="contributionType"
              labels-prefix="campaignDesigner.campaignSetup.contributionType"
              type="picklist"
              v-else />
          </div>

          <!-- Segment Type -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.segmentType.label')"
              :options="localConfig.campaignData.segmentType.options"
              :validation="['required']"
              :sortLabel=true
              labels-prefix="campaignDesigner.campaignSetup.segmentType"
              ref="data_segmentType"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="segmentType" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.segmentType.label')"
              :options="localConfig.campaignData.segmentType.options"
              :value="segmentType"
              labels-prefix="campaignDesigner.campaignSetup.segmentType"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Content Classification -->
        <div class="row">

          <!-- Content Classification -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.contentClassification.label')"
              :options="localConfig.campaignData.contentClassification.options"
              :validation="['required']"
              labels-prefix="campaignDesigner.campaignSetup.contentClassification"
              ref="data_contentClassification"
              v-if="isCreate || isEdit"
              v-model="contentClassification" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.contentClassification.label')"
              :options="localConfig.campaignData.contentClassification.options"
              :value="contentClassification"
              labels-prefix="campaignDesigner.campaignSetup.contentClassification"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Finality, Manager -->
        <div class="row">
          <!-- Finality -->
          <div class="slds-form-element col slds-size--medium">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.finality.label')"
              :options="localConfig.campaignData.finality.options"
              :tooltip="$t('campaignDesigner.campaignSetup.finality.tooltip.afterSales')"
              :validation="['required']"
              :sortLabel=true
              tooltip-direction="right"
              labels-prefix="campaignDesigner.campaignSetup.finality"
              ref="data_finality"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="finality" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.finality.label')"
              :options="localConfig.campaignData.finality.options"
              :value="finality"
              labels-prefix="campaignDesigner.campaignSetup.finality"
              type="picklist"
              v-else />
          </div>

          <!-- Manager -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.manager.label')"
              :options="localConfig.campaignData.manager.options"
              labels-prefix="campaignDesigner.campaignSetup.manager"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="manager" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.manager.label')"
              :options="localConfig.campaignData.manager.options"
              :value="manager"
              labels-prefix="campaignDesigner.campaignSetup.manager"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- CCDB Report Enabled, CCDB Report Type -->
        <div class="row">
          <!-- CCDB Report Enabled -->
          <div class="slds-form-element col slds-size--medium">
            <Input
              :label="$t('campaignDesigner.campaignSetup.ccdbReportEnabled')"
              type="checkbox"
              v-if="isCreate || isEdit"
              v-model="ccdbReportEnabled" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.ccdbReportEnabled')"
              :value="ccdbReportEnabled"
              type="checkbox"
              v-else />
          </div>

          <!-- CCDB Report Type -->
          <div class="slds-form-element slds-size--medium col">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.ccdbReportType.label')"
              :options="localConfig.campaignData.ccdbReportType.options"
              labels-prefix="campaignDesigner.campaignSetup.ccdbReportType"
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="ccdbReportType" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.ccdbReportType.label')"
              :options="localConfig.campaignData.ccdbReportType.options"
              :value="ccdbReportType"
              labels-prefix="campaignDesigner.campaignSetup.ccdbReportType"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Jeep Wave -->
        <div class="row">
           <!-- Jeep Wave -->
          <div class="slds-form-element col slds-size--medium" v-if="localConfig.campaignData.jeepWave && campaignBrands.includes('057')">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.jeepWave')"
              :options="localConfig.campaignData.jeepWave.options"
              multipicklist
              v-if="isCreate || isEdit"
              v-model="jeepWave" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.jeepWave')"
              :options="localConfig.campaignData.jeepWave.options"
              :value="jeepWave"
              type="multipicklist"
              v-else />
          </div>
        </div>

        <!-- Description, Touchpoint -->
        <div class="row">
          <!-- Description -->
          <div class="slds-form-element col slds-size--medium">
            <div class="slds-form-element slds-size--medium">
              <TextArea
                :label="$t('campaignDesigner.campaignSetup.description')"
                v-if="isCreate || isEdit"
                v-model="description" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.description')"
                :value="description"
                type="text"
                v-else />
            </div>
          </div>

          <!-- Touchpoint -->
          <div class="slds-form-element slds-size--medium col" v-if="localConfig.campaignData.touchpoint">
            <Picklist
              :label="$t('campaignDesigner.campaignSetup.touchpoint')"
              :options="localConfig.campaignData.touchpoint.options"
              :validation="['required']"
              ref="data_touchpoint"
              required
              searchable
              show-empty-value
              v-if="isCreate || isEdit"
              v-model="touchpoint" />

            <OutputField
              :label="$t('campaignDesigner.campaignSetup.touchpoint')"
              :options="localConfig.campaignData.touchpoint.options"
              :value="touchpoint"
              type="picklist"
              v-else />
          </div>
        </div>

        <!-- Push -->
        <Card additional-classes="slds-card_boundary slds-m-top--small" :title="$t('campaignDesigner.campaignSetup.push')" v-if="campaignChannel.includes('push')">
          <!-- Push list -->
          <div class="row">
            <div class="slds-form-element col">
                <Spinner v-if="!gotAssetLists && (isCreate || isEdit)" style="scale:50%;" />
                  <div v-if="gotAssetLists || !(isCreate || isEdit)" >
                    <Picklist
                      :label="$t('campaignDesigner.campaignSetup.push_list')"
                      :options="push_list"
                      :tooltip="$t('campaignDesigner.campaignSetup.push_list_tooltip')"
                      tooltip-direction="right"
                      multipicklist
                      searchable
                      ref="push_list"
                      v-if="(isCreate || isEdit)"
                      v-model="push_selected" />

                    <OutputField
                      :label="$t('campaignDesigner.campaignSetup.push_list')"
                      :options="push_selected"
                      :value="push_selected"
                      type="multipicklist"
                  v-else />
                  </div>
            </div>
          </div>
        </Card>

        <!-- SMS -->
        <Card additional-classes="slds-card_boundary slds-m-top--small" :title="$t('campaignDesigner.campaignSetup.sms')" v-if="campaignChannel.includes('sms')">
          <!-- SMS list -->
          <div class="row">
            <div class="slds-form-element col">
                <Spinner v-if="!gotAssetLists && (isCreate || isEdit)" style="scale:50%;" />
                  <div v-if="gotAssetLists || !(isCreate || isEdit)" >
                    <Picklist
                      :label="$t('campaignDesigner.campaignSetup.sms_list')"
                      :options="sms_list"
                      :tooltip="$t('campaignDesigner.campaignSetup.sms_list_tooltip')"
                      tooltip-direction="right"
                      multipicklist
                      searchable
                      ref="sms_list"
                      v-if="(isCreate || isEdit)"
                      v-model="sms_selected" />

                  <OutputField
                      :label="$t('campaignDesigner.campaignSetup.sms_list')"
                      :options="sms_selected"
                      :value="sms_selected"
                      type="multipicklist"
                  v-else />
                  </div>
            </div>
          </div>
        </Card>

        <!-- UTM -->
        <Card additional-classes="slds-card_boundary slds-m-top--small" :title="$t('campaignDesigner.campaignSetup.email')" v-if="campaignChannel.includes('email')">
          <!-- UTM email list -->
          <div class="row">
            <div class="slds-form-element col">
                <Spinner v-if="!gotAssetLists && (isCreate || isEdit)" style="scale:50%;" />
                  <div v-if="gotAssetLists || !(isCreate || isEdit)" >
                    <Picklist
                  :label="$t('campaignDesigner.campaignSetup.utm_list')"
                  :options="utm_list"
                  :tooltip="$t('campaignDesigner.campaignSetup.email_list_tooltip')"
                  tooltip-direction="right"
                  multipicklist
                  searchable
                  ref="utm_list"
                  v-if="(isCreate || isEdit)"
                  v-model="utm_selected" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.utm_list')"
                  :options="utm_selected"
                  :value="utm_selected"
                  type="multipicklist"
                  v-else />
                  </div>
            </div>
          </div>

          <!-- UTM Source -->
          <div class="row">
            <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.utm_source')"
                ref="utm_source"
                v-if="isCreate || isEdit"
                :disabled="true"
                v-model="utm_source_computed" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.utm_source')"
                :disabled="true"
                :value="utm_source_computed"
                v-else />
            </div>
          </div>
          </div>

          <!-- UTM Medium -->
          <div class="row">
          <div class="slds-form-element col">
            <div class="slds-form-element slds-size--medium">
              <Input
                :label="$t('campaignDesigner.campaignSetup.utm_medium')"
                ref="utm_medium"
                v-if="isCreate || isEdit"
                :disabled="true"
                v-model="utm_medium_computed" />

              <OutputField
                :label="$t('campaignDesigner.campaignSetup.utm_medium')"
                :disabled="true"
                :value="utm_medium_computed"
                v-else />
            </div>
          </div>
          </div>

          <!-- UTM Campaign -->
          <div class="row">
            <div class="slds-form-element col">
              <div class="slds-form-element slds-size--medium">
                <Input
                  :label="$t('campaignDesigner.campaignSetup.utm_campaign')"
                  ref="utm_campaign"
                  v-if="isCreate || isEdit"
                  :disabled="true"
                  v-model="utm_campaign" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.utm_campaign')"
                  :disabled="true"
                  :value="utm_campaign"
                  v-else />
              </div>
            </div>
          </div>

          <!-- UTM Content -->
          <div class="row">
            <div class="slds-form-element col">
              <div class="slds-form-element slds-size--medium">
                <Input
                  :label="$t('campaignDesigner.campaignSetup.utm_content')"
                  ref="utm_content"
                  v-if="isCreate || isEdit"
                  v-model="utm_content" />

                <OutputField
                  :label="$t('campaignDesigner.campaignSetup.utm_content')"
                  :value="utm_content"
                  v-else />
              </div>
            </div>
          </div>

          </Card>

      </Card>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .col {
    flex-grow: 1;
  }

  .type-color-container {
    margin-right: 10px;
  }

  .full-height {
    height: 100%;
    overflow-y: auto;
  }

  Input {
    width: unset !important;
  }
</style>
